<template>
  <div
    :class="`modal fade px-0 ${$props.value ? 'show d-block' : 'd-none'}`"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body container-fluid text-center">
          <img
            :src="$props.src"
            loading="lazy"
            style="width:100%;max-width:470px;"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    methods: {
        close() {
            this.$emit( 'input', false );
        }
    },
    props: {
        value: {
            type: Boolean,
            required: true,
            default: () => false
        },
        src: {
            type: String,
            required: true,
            default: () => ''
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/templates/ImgPreviewModal.vue